import Utils from "../../src/utils/Utils";
import { BaseModel } from "./BaseModel";
import ISpinData, {
    IOverlayData,
    IReSpinData,
    ISpinificationData,
    IWinData,
    OverlayType,
} from "../server/data/ISpinData";
import { IBonusData, ICustomData } from "../server/data/ICustomData";
import GameModel from "./GameModel";
import gameModel from "./GameModel";
import App from "../../../core/src/App";
import betModel from "./BetModel";
import SymbolMap from "../../src/utils/SymbolMap";
// import { ICascadeReelData } from "../../../../game/src/server/data/IPlayData";

class SpinModel extends BaseModel<ISpinData> {
    public winAmount: number = 0;
    public currentWin: number = 0;
    public accumulatedWin: number = 0;
    public tempWinAmount: number = 0; // used for counting of current win in cascades
    public reelHeight: number = 3;
    public spinEnded: boolean = true;
    public freespinsNum: number = 0;
    public totalFreeSpins: number = 0;
    public freespinsWon: number = 0;
    public freeSpinRetriggered: number = 0;
    public roundType: string = "";
    public freespinsFlags: { [flagName: string]: boolean } = {};
    public overlays: IOverlayData[] = [];
    public bonuses: IBonusData[] = [];
    public reelStopSymbols: number[][] = [];
    public reelFinalSymbols: number[][] = [];
    public reelSets: any[][][] = [];
    public reelSetIndex: number = 0;
    public stopPositions: number[] = [];
    public currentPositions: number[] = [];
    public spinification: ISpinificationData = null;
    public winsData: IWinData[] = [];
    public winsMultiplier?: number = 1;
    public winsWildMultiplier?: number = 1;
    public scatterWin: number = 0;
    public isFree: boolean = false;
    public freespinsRunning: boolean = false;
    public freespinWinnings: number = 0;
    public stopImmediately: boolean;
    // public spinPayload: any = [];
    public spinFinished: boolean = true;
    public fsRetriggerFlag: boolean = false;
    public freespinsToShow: number = 0;
    public generations: any[] = [];
    public freespins: any = null;
    public currentGeneration: number = 0;
    public bonusWin: boolean = false;
    public isInRespin: boolean = false;
    public firstWildIndex = null;
    public wildVersion = null;
    public firstAndThird: boolean;
    public roundFinish = false;
    public symbolReplacements?:
        | { [original: string]: any }
        | { [original: number]: any } = {};

    // Cascading properties
    public cascades: SpinModel[] = [];
    public cascadeIndex: number = -1;
    public cascadeWinOffsets: number[] = [];

    // Token properties
    public tokensCount = {};

    // ReSpin data
    reSpinData?: IReSpinData = {
        awarded: 0,
        reTriggered: 0,
        win: 0,
        remaining: 0,
    };

    tempSymbols: any;
    respinCount = 0;

    public hasOverlay(type?: OverlayType): boolean {
        let currentOverlays = this.getCurrentSpinProperty("overlays");
        let hasOverlays = Boolean(currentOverlays && currentOverlays.length);
        if (type && hasOverlays) {
            hasOverlays = false;
            currentOverlays.forEach((overlay) => {
                if (overlay.type === type) {
                    hasOverlays = true;
                }
            });
        }
        return hasOverlays;
    }

    public hasReSpins(): boolean {
        return (
            this.reSpinData &&
            this.reSpinData.awarded > 0 &&
            this.reSpinData.remaining > 0
        );
    }

    public getCurrentWinsData() {
        return this.getCurrentSpinProperty("winsData");
    }

    public getCurrentCascadeWinMap() {
        let { numVisibleLines, numReels } = GameModel.gameConfig;
        let markedArr = [];
        let winOffsets = this.getCurrentSpinProperty("cascadeWinOffsets");

        // Non-winning spins have no win offsets - so check for it
        if (winOffsets && winOffsets.length != 0) {
            for (let reelIndex = 0; reelIndex < numReels; reelIndex++) {
                markedArr[reelIndex] = [];
                for (let rowIndex = 0; rowIndex < numVisibleLines; rowIndex++) {
                    markedArr[reelIndex][rowIndex] = winOffsets.includes(
                        rowIndex * numReels + reelIndex
                    );
                }
            }
        }

        return markedArr;
    }

    public getCurrentCascadeExplodeMap() {
        let { numVisibleLines, numReels } = GameModel.gameConfig;
        let markedArr = [];
        let explodesOffsets = this.getCurrentSpinProperty("cascadeExplodesOffsets");

        // Non-winning spins have no win offsets - so check for it
        if (explodesOffsets && explodesOffsets.length != 0) {
            for (let reelIndex = 0; reelIndex < numReels; reelIndex++) {
                markedArr[reelIndex] = [];
                for (let rowIndex = 0; rowIndex < numVisibleLines; rowIndex++) {
                    markedArr[reelIndex][rowIndex] = explodesOffsets.includes(
                        rowIndex * numReels + reelIndex
                    );
                }
            }
        }

        return markedArr.length ? markedArr : this.getCurrentCascadeWinMap();
    }

    public getOverlay(type: OverlayType): IOverlayData  {
        let currentOverlays = this.getCurrentSpinProperty("overlays");
        for (let overlayId in currentOverlays) {
            if (currentOverlays[overlayId].type === type) {
                return Utils.deepClone(currentOverlays[overlayId]);
            }
        }
        return null;
    }

    public getOverlays(type: OverlayType): IOverlayData[] {
        let currentOverlays = this.getCurrentSpinProperty("overlays");
        let overlays: IOverlayData[]  = [];
        for (let overlayId in currentOverlays) {
            if (currentOverlays[overlayId].type === type) {
                overlays.push(Utils.deepClone(currentOverlays[overlayId])) ;
            }
        }
        return overlays;
    }

    public hasScatterWin(): boolean {
        return this.scatterWin > 0;
    }

    // public resolveSpinPayload() {
    //     if (Array.isArray(this.spinPayload)) {
    //         Utils.serialize(this.spinPayload.shift(), this);
    //     } else {
    //         Utils.serialize(this.spinPayload, this);
    //     }
    // }

    update(data?: any) {
        let oldData = Utils.deepClone(this.processedData);
        super.update(data);
        // let processedData = this.processData(data);
        // if (processedData.length || data) {
        if (
            (oldData != this.processedData && this.processedData.length) ||
            data
        ) {
            this.roundFinish = false;
        }
    }

    public updateFreespinWinnings() {
        this.freespinWinnings += this.getCurrentSpinProperty("currentWin");
    }

    public hasResultForReel(reelIdx: number): boolean {
        return (
            this.reelStopSymbols[reelIdx] != undefined &&
            this.reelStopSymbols[reelIdx].length > 0
        );
    }

    public getStopSymbolsForReels(
        reelIdxs: number[],
        setIndex?: number
    ): any[] {
        let result = [];

        reelIdxs.forEach((reel, index) => {
            result[index] = this.getStopSymsForReel(reel, setIndex);
        });

        return result;
    }

    private getCurrentStopPositions(reelIdx) {
        // The current stop positions
        let currentStopPositions = this.getCurrentSpinProperty(
            "stopPositions"
        )?.[reelIdx];

        return currentStopPositions != null && currentStopPositions != undefined
            ? currentStopPositions
            : GameModel.gameConfig.defaultStopPositions[reelIdx];
    }

    public getCurrentWinsMultiplier() {
        return this.getCurrentSpinProperty("winsMultiplier");
    }

    public getAccumulatedWin() {
        return this.getCurrentSpinProperty("accumulatedWin");
    }

    public getCurrentWin() {
        return (
            // If there is a cascade there will be currentWin and accumulatedWin
            this.getCurrentSpinProperty("currentWin") ||
            // If it's a regular spin - maybe we have just winAmount
            this.getCurrentSpinProperty("winAmount")
        );
    }

    public getCurrentSpinProperty(property: keyof ISpinData) {
        if (
            this.cascades &&
            this.cascadeIndex != -1 &&
            this.cascades.length > 0 &&
            this.cascadeIndex < this.cascades.length
        ) {
            // If there are cascades to be shown - get the prop from there

            return this.cascades[this.cascadeIndex][property];
        } else {
            // If not - get it from the current spin model
            return this[property];
        }
    }

    public getNextSpinProperty(property: keyof ISpinData) {
        if (
            this.cascades &&
            this.cascadeIndex != -1 &&
            this.cascades.length > 0 &&
            this.cascadeIndex + 1 < this.cascades.length
        ) {
            // If there are cascades to be shown - get the prop from there

            return this.cascades[this.cascadeIndex + 1][property];
        } else {
            // If not - get it from the current spin model
            return this[property];
        }
    }

    public getStopSymsForReel(
        reelIdx: number,
        setIndex?: number,
        reelExtraSymbols?: number,
        numSyms?: number
    ) {
        const extraSymbols = isNaN(reelExtraSymbols)
            ? GameModel.gameConfig.reelExtraSymbols || 0
            : reelExtraSymbols;

        if (!numSyms) {
            numSyms = this.reelStopSymbols[reelIdx]
                ? this.reelStopSymbols[reelIdx].length
                : this.getSymsForReel(reelIdx);
        }

        const stopPosition = this.getCurrentStopPositions(reelIdx);

        return this.getNumberSymbolsAfterStop(
            reelIdx,
            stopPosition - extraSymbols,
            numSyms + extraSymbols * 2,
            setIndex
        );
    }

    public getFinalSymsForReels(reelIdxs: number[]): any[] {
        let result = [];
        reelIdxs.forEach((reel, index) => {
            result[index] = this.getFinalSymsForReel(reel);
        });

        return result;
    }

    public getCurrentFinalSymbols() {
        return this.getCurrentSpinProperty("reelFinalSymbols") as number[][];
    }

    public getFinalSymsForReel(reelIdx: number) {
        return this.reelFinalSymbols[reelIdx];
    }

    public getNextStopPosition(reelIdx: number, setIndex?: number): number {
        setIndex =
            setIndex != null && setIndex != undefined
                ? setIndex
                : this.reelSetIndex;

        let stopPosition: number;

        if (this.currentPositions[reelIdx] != undefined) {
            stopPosition = this.currentPositions[reelIdx];
        } else if (this.stopPositions[reelIdx] != undefined) {
            stopPosition = this.stopPositions[reelIdx];
        } else if (GameModel.gameConfig.defaultStopPositions[reelIdx]) {
            stopPosition = GameModel.gameConfig.defaultStopPositions[reelIdx];
        }

        if (stopPosition == undefined || isNaN(stopPosition)) {
            stopPosition = 0;
        }

        stopPosition++;
        if (stopPosition > this.reelSets[setIndex][reelIdx].length - 1) {
            stopPosition =
                stopPosition - this.reelSets[setIndex][reelIdx].length;
        }

        const syms = SymbolMap.parseSymbols(
            this.getNumberSymbolsAfterStop(reelIdx, stopPosition, 1, setIndex)
        );
        this.currentPositions[reelIdx] = stopPosition;

        return syms[0];
    }

    public getNumberSymbolsAfterStop(
        reelIdx: number,
        stopPosition: number,
        count: number,
        setIndex?: number
    ): any[] {
        setIndex =
            setIndex != null && setIndex != undefined
                ? setIndex
                : this.reelSetIndex;
        const finalSyms = [];

        if (this.reelSets.length > 0) {
            if (!(this.reelSets[setIndex][reelIdx].length === 0)) {
                while (
                    stopPosition >= this.reelSets[setIndex][reelIdx].length ||
                    stopPosition < 0
                ) {
                    if (stopPosition < 0) {
                        stopPosition =
                            this.reelSets[setIndex][reelIdx].length +
                            stopPosition;
                    }
                    if (
                        stopPosition >= this.reelSets[setIndex][reelIdx].length
                    ) {
                        stopPosition =
                            stopPosition -
                            this.reelSets[setIndex][reelIdx].length;
                    }
                }
            }
        }

        for (let symIdx = 0; symIdx < count; symIdx++) {
            // TODO initial symbools set
            let sym = 1;
            if (
                this.reelSets.length != 0 &&
                this.reelSets[setIndex][reelIdx] &&
                this.reelSets[setIndex][reelIdx].length
            ) {
                let index = stopPosition + symIdx;
                if (index > this.reelSets[setIndex][reelIdx].length - 1) {
                    index = index - this.reelSets[setIndex][reelIdx].length;
                }
                let id = this.reelSets[setIndex][reelIdx][index];
                sym = SymbolMap.parseSymbols([id])[0]; // TODO FIX MAPING
            } else {
                sym = this.getRandomSymId(reelIdx);
            }

            finalSyms.push(sym);
        }

        return finalSyms;
    }

    public getSymsForReel(reelIdx: number): number {
        return gameModel.gameConfig.layout[reelIdx];
    }

    // TODO hold logic
    public getPlayerHoldsPattern() {
        return [false, false, false, false, false];
    }

    // TODO add reelSet support
    public getRandomSymId(reelId = 0, restrict = false) {
        const symIds = App.config.symbolIds;

        let rndId = symIds[Math.floor(Math.random() * symIds.length)];

        if (restrict == true && App.config.restrictedSymbols) {
            while (App.config.restrictedSymbols.indexOf(rndId) != -1) {
                rndId = symIds[Math.floor(Math.random() * symIds.length)];
            }
        }

        return rndId;
    }

    public setReelSetIndex(index: number) {
        this.reelSetIndex = index;
    }

    public enterFreespins() {
        this.freespinsRunning = true;
        if (!this.fsRetriggerFlag) {
            // Set the initial FS win to the triggering spin win
            this.freespinWinnings = this.currentWin
        }
        this.freespinsToShow = this.freespinsNum;
        this.fsRetriggerFlag = true;
    }

    public exitFreespins() {
        this.freespinsFlags = {};
        this.freespinsRunning = false;
        this.fsRetriggerFlag = false;
        this.freespinWinnings = 0;
    }

    public isInFreespins() {
        return this.freespinsRunning;
    }

    public hasWinnings(): boolean {
        // If there is a cascade - check where we are
        if (this.cascades && this.cascades.length > 0) {
            // If we're still in the cascades - check the cascade win
            if (this.cascadeIndex < this.cascades.length) {
                return this.getCurrentSpinProperty("winAmount") > 0;
            } else {
                // Else the cascade is over and the main winAmount is the accumulated total - so no spin win
                return false;
            }
        } else {
            // Otherwise - check the main winAmount
            return this.winAmount > 0;
        }
    }

    public hasBigWin(): boolean {
        return (
            this.getWinRatio() >
            (GameModel.gameConfig as any).bigWinRatioLevels[0]
        );
    }

    public hasFreespinsWon(): boolean {
        return this.freespinsWon > 0;
    }

    public hasFreespins(): boolean {
        return this.freespinsNum > 0;
    }

    public hasRemovedSymbols(): boolean {
        return this.generations.length > 1;
    }

    //TODO - this is duplicated
    public getRemovedSymbols() {
        const respinReels: boolean[] = new Array(5).fill(false);
        const removedCoords = this.generations[this.currentGeneration]
            .removedSymbols;
        const removedCoordsLen = removedCoords.length;
        for (let i = 0; i < removedCoordsLen; i++) {
            const reelIndex = removedCoords[i].x - 1;
            respinReels[reelIndex] = true;
        }
        return respinReels;
    }

    public getCurrentGenSymbols() {
        const genSymbols = this.generations[this.currentGeneration]?.symbols || [];
        return genSymbols;
    }

    public hasNextGeneration() {
        return this.currentGeneration < this.generations.length - 1;
    }

    public getNextGenSymbols() {
        if (this.hasNextGeneration()) {
            this.currentGeneration++;
        }
        const genSymbols = this.generations[this.currentGeneration]?.symbols || [];

        return genSymbols;
    }

    public getWinningSymbols() {
        const winningSymbols = this.createSymArr(
            gameModel.gameConfig.numReels,
            gameModel.gameConfig.symbolCount,
            false
        );
        // coordinates are starting from 1 and because of that every calculation is made with -1
        let winsData = this.getCurrentSpinProperty("winsData");
        for (let i = 0; i < winsData.length; i++) {
            this.resolveWinCoords(winsData[i].coordinates, winningSymbols);
        }
        return winningSymbols;
    }

    public getWinRatio() {
        return this.winAmount / betModel.totalBet;
    }

    getWinsoundName() {
        const winSoundRatios = GameModel.gameConfig.winSoundRatios;
        const currentWinRatio = this.getWinRatio();
        let soundName;
        for (let i = winSoundRatios.length - 1; i >= 0; i--) {
            if (winSoundRatios[i].winRatio <= currentWinRatio) {
                soundName = winSoundRatios[i].sound;
                break;
            }
        }
        return soundName;
    }

    public generateReelsets() {
        if (this.reelSets.length != 0) {
            return;
        }
        for (let i = 0; i < 2; i++) {
            this.reelSets[i] = this.createSymArr(
                GameModel.gameConfig.numReels,
                25,
                null,
                {
                    min: GameModel.gameConfig.symbolIds[0],
                    max:
                        GameModel.gameConfig.symbolIds[
                            GameModel.gameConfig.symbolIds.length - 1
                        ],
                }
            );
        }
    }

    public insertResultInReelset() {
        let reelset;
        if (this.freespinsRunning) {
            reelset = this.reelSets[1];
        } else {
            reelset = this.reelSets[0];
        }

        for (let i = 0; i < this.reelStopSymbols.length; i++) {
            for (let j = 0; j < this.reelStopSymbols[i].length; j++) {
                const reelStopSymbolElement = this.reelStopSymbols[i][j];
                reelset[i][j] = reelStopSymbolElement;
            }
        }
    }

    private resolveWinCoords(
        coordinatesArr: { x: number; y: number }[],
        resultArr
    ) {
        for (let i = 0; i < coordinatesArr.length; i++) {
            const currentCoordinate = coordinatesArr[i];
            const reelIndex = currentCoordinate.x - 1;
            const symbolIndex = currentCoordinate.y - 1;
            resultArr[reelIndex][symbolIndex] = true;
        }
        return resultArr;
    }

    /**
     * Creates a matrix of symbols with given parameters
     * @param col
     * @param row
     * @param emptyVal - empty value to be inserted. Defaults to 0
     * @param random - whether a random number should be drawn for each position
     */
    public createSymArr(
        col,
        row,
        emptyVal: any = 0,
        random?: { min: number; max: number }
    ) {
        const result = [];
        for (let i = 0; i < col; i++) {
            result[i] = [];
            for (let j = 0; j < row; j++) {
                if (random) {
                    const min = Math.ceil(random.min);
                    const max = Math.floor(random.max);
                    result[i][j] =
                        Math.floor(Math.random() * (max - min + 1)) + min;
                } else {
                    result[i][j] = emptyVal;
                }
            }
        }
        return result;
    }
}

export default new SpinModel();
